module.exports = __webpack_public_path__ + "862a3d128feed61c2aec862537832677.fbx";